import {EditorToolbar} from 'vue2-editor'

export const stringLimiter = (value: string, limit: number): string => value.length > limit
  ? value.substring(value.length, limit - 3) + '...'
  : value;


export const getToolbarConfig = (): EditorToolbar[] => [
  ['bold', 'italic', 'underline'],
  ['blockquote', 'code-block'],
  [
    {align: 'center'},
    {align: 'right'},
    {align: 'justify'},
    {align: ''},
  ],
  [{list: 'ordered'}, {list: 'bullet'}, {list: 'checked'}],
  [{header: [false, 1, 2, 3, 4, 5, 6]}],
  [{size: ['small', false, 'large', 'huge']}],
  [{indent: '-1'}, {indent: '+1'}],
  ['clean'],
];

export function bottomVisible(): boolean {
  const scrollY = window.scrollY;
  const visible = document.documentElement.clientHeight;
  const pageHeight = document.documentElement.scrollHeight;
  const bottomOfPage = visible + scrollY >= pageHeight;
  return bottomOfPage || pageHeight < visible
}

export function compare(a: number | string | undefined,
                        b: number | string | undefined,
                        isAsc: boolean): number {
  if (!a || !b) {
    return 1;
  }
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export function nFormatter(num: number, digits: number = 1) {
  const simbols = [
    {value: 1, symbol: ''},
    {value: 1e3, symbol: 'K'},
    {value: 1e6, symbol: 'MI'},
    {value: 1e9, symbol: 'BI'},
    {value: 1e12, symbol: 'TRI'},
  ];

  const regex = /.0+$|(.[0-9]*[1-9])0+$/;
  let index;

  for (index = simbols.length - 1; index > 0; index--) {
    if (Math.abs(num) >= simbols[index].value) {
      break
    }
  }

  return (
    (num / simbols[index].value).toFixed(digits).replace(regex, '$1') +
    simbols[index].symbol
  )
}

export const youtubeUrlParser = (url: string) => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length == 11) ? match[7] : false;
}

export const vimeoUrlParser = (url: string) => {
  const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
  const match = url.match(regExp);
  return (match && match[5]) ? match[5] : false;
}
